import { useEffect, useState } from "react";
import type { ColumnDef } from "@tanstack/react-table";
import { fetchServiceAccounts } from "../lib/api";
import type { ServiceAccount } from "../lib/types";
import DataTable from "../components/DataTable";
import WriteOpsHint from "../components/WriteOpsHint";
import { SA_WRITE_OPS } from "../writeops/service_accounts";

const COLS: ColumnDef<ServiceAccount, any>[] = [
  { header: "ID", accessorKey: "id" },
  {
    header: "Display",
    accessorKey: "display_name",
    cell: (c) => c.getValue() ?? "—",
  },
  { header: "Pinned Realm", accessorKey: "pinned_realm" },
  {
    header: "Scopes",
    accessorKey: "scopes",
    cell: (c) => (
      <span className="text-xs font-mono text-kw-text-muted">
        {((c.getValue() as string[]) ?? []).join(" ") || "—"}
      </span>
    ),
  },
  { header: "Status", accessorKey: "status" },
];

export default function ServiceAccountsRoute() {
  const [sas, setSas] = useState<ServiceAccount[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setSas(await fetchServiceAccounts());
      } catch (e: any) {
        setError(e.message ?? String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="px-8 py-6 space-y-6">
      <h2 className="text-lg font-medium">Service Accounts</h2>
      {loading && <div className="text-kw-text-muted text-sm">Lade...</div>}
      {error && <div className="text-red-400 text-sm">{error}</div>}
      {!loading && !error && (
        <DataTable
          columns={COLS}
          data={sas}
          emptyHint="Keine Service-Accounts — V1-Solo-Setup nutzt den statischen Bearer."
        />
      )}
      <WriteOpsHint title="Service-Account-Write-Ops" ops={SA_WRITE_OPS} />
    </div>
  );
}
